import React from 'react'
import { ThemeProvider } from 'emotion-theming'
import normalizeTheme from './normalizeTheme'

export default Component => ({ theme, ...rest }) => {
  return (
    <ThemeProvider theme={normalizeTheme(theme)}>
      <Component {...rest} />
    </ThemeProvider>
  )
}



// WEBPACK FOOTER //
// ../src/utils/withTheme.js